/**
 * @deprecated - use platform instead
 */
export type FieldType =
  | 'hidden'
  | 'text'
  | 'nullableText'
  | 'price'
  | 'vatType'
  | 'password'
  | 'number'
  | 'integer'
  | 'checkbox'
  | 'switch'
  | 'select'
  | 'phone'
  | 'date'
  | 'year'
  | 'chips'
  | 'country-select';
